(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
class SliderProgress extends HTMLElement {
  connectedCallback() {
    this._fill = this.querySelector('[data-fill]');
    this._onScroll = this._onScroll.bind(this);
    this._raf = null;
    requestAnimationFrame(() => this._init());
  }

  disconnectedCallback() {
    if (this._slider) {
      this._slider.removeEventListener('scroll', this._onScroll);
    }
    if (this._ro) {
      this._ro.disconnect();
    }
  }

  _init() {
    const id = this.getAttribute('aria-controls');
    if (!id) return;

    this._slider = document.getElementById(id);
    if (!this._slider) return;

    this._slider.addEventListener('scroll', this._onScroll, { passive: true });
    this._ro = new ResizeObserver(() => this._update());
    this._ro.observe(this._slider);
    this._update();
  }

  _onScroll() {
    if (this._raf) return;
    this._raf = requestAnimationFrame(() => {
      this._update();
      this._raf = null;
    });
  }

  _update() {
    if (!this._slider || !this._fill) return;

    const el = this._slider;
    const sw = el.scrollWidth;
    const cw = el.clientWidth;
    const container = this.closest('.slider-controls');
    const sideNav = el.parentElement ? el.parentElement.querySelector('.fc-side-nav-wrap') : null;

    if (sw <= cw) {
      if (container) container.hidden = true;
      if (sideNav) sideNav.hidden = true;
      return;
    }

    if (container) container.hidden = false;
    if (sideNav) sideNav.hidden = false;

    const maxScroll = sw - cw;
    const scrollRatio = maxScroll > 0 ? Math.abs(el.scrollLeft) / maxScroll : 0;
    const fillWidth = (scrollRatio * (1 - cw / sw) + cw / sw) * 100;

    this._fill.style.width = fillWidth + '%';
  }
}

if (!customElements.get('slider-progress')) {
  customElements.define('slider-progress', SliderProgress);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.js-kik-richtext-lists li').forEach(function(li) {
    li.innerHTML = li.innerHTML.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  });

  document.querySelectorAll('[data-sticky-quantity]').forEach(function(stickyInput) {
    var formId = stickyInput.getAttribute('data-form-id');
    if (!formId) return;

    var mainInput = document.querySelector(
      'input[name="quantity"][form="' + formId + '"]:not([data-sticky-quantity])'
    );

    if (mainInput) {
      stickyInput.addEventListener('change', function() {
        mainInput.value = stickyInput.value;
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      mainInput.addEventListener('change', function() {
        stickyInput.value = mainInput.value;
      });
    } else {
      var hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'quantity';
      hiddenInput.value = stickyInput.value;
      hiddenInput.setAttribute('form', formId);
      stickyInput.parentElement.appendChild(hiddenInput);
      stickyInput.addEventListener('change', function() {
        hiddenInput.value = stickyInput.value;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-product-bundle"] && !Shopify.designMode) return;
  try {
    
class SliderProgress extends HTMLElement {
  connectedCallback() {
    this._fill = this.querySelector('[data-fill]');
    this._onScroll = this._onScroll.bind(this);
    this._raf = null;
    requestAnimationFrame(() => this._init());
  }

  disconnectedCallback() {
    if (this._slider) {
      this._slider.removeEventListener('scroll', this._onScroll);
    }
    if (this._ro) {
      this._ro.disconnect();
    }
  }

  _init() {
    const id = this.getAttribute('aria-controls');
    if (!id) return;

    this._slider = document.getElementById(id);
    if (!this._slider) return;

    this._slider.addEventListener('scroll', this._onScroll, { passive: true });
    this._ro = new ResizeObserver(() => this._update());
    this._ro.observe(this._slider);
    this._update();
  }

  _onScroll() {
    if (this._raf) return;
    this._raf = requestAnimationFrame(() => {
      this._update();
      this._raf = null;
    });
  }

  _update() {
    if (!this._slider || !this._fill) return;

    const el = this._slider;
    const sw = el.scrollWidth;
    const cw = el.clientWidth;
    const container = this.closest('.slider-controls');

    if (sw <= cw) {
      if (container) container.hidden = true;
      return;
    }

    if (container) container.hidden = false;

    const maxScroll = sw - cw;
    const scrollRatio = maxScroll > 0 ? Math.abs(el.scrollLeft) / maxScroll : 0;
    const fillWidth = (scrollRatio * (1 - cw / sw) + cw / sw) * 100;

    this._fill.style.width = fillWidth + '%';
  }
}

if (!customElements.get('slider-progress')) {
  customElements.define('slider-progress', SliderProgress);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-product-comparison-table"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kik-scrollable-table')) {
  class KikScrollableTable extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
    }

    get scrollContainer() {
      return this.querySelector('.kik-scrollable-table__table');
    }

    get prevBtn() {
      return this.querySelector('[is="previous-button"]');
    }

    get nextBtn() {
      return this.querySelector('[is="next-button"]');
    }

    get scrollbarThumb() {
      return this.querySelector('.kik-scrollable-table__scrollbar-thumb');
    }

    get controls() {
      return this.querySelector('.kik-scrollable-table__controls');
    }

    connectedCallback() {
      this._bindEvents();
      requestAnimationFrame(() => {
        this._updateColumnWidth();
        this._updateControls();
        this._updateScrollbar();
        this._updateNavButtons();
      });
    }

    disconnectedCallback() {
      this._unbindEvents();
    }

    _bindEvents() {
      const container = this.scrollContainer;
      if (container) {
        container.addEventListener('scroll', this._onScroll, { passive: true });
      }
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollPrev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollNext());
      }
      const scrollToProductBtn = this.querySelector('[data-scroll-to-product]');
      if (scrollToProductBtn) {
        scrollToProductBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const target = document.querySelector('product-info, .product__info-wrapper, .product-form');
          if (target) {
            const top = target.getBoundingClientRect().top + window.scrollY;
            const stickyHeader = document.querySelector('sticky-header, .header-wrapper');
            const offset = stickyHeader ? stickyHeader.offsetHeight : 0;
            window.scrollTo({ top: top - offset - 16, behavior: 'smooth' });
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      }
      this._resizeObserver = new ResizeObserver(this._onResize);
      if (container) {
        this._resizeObserver.observe(container);
      }
    }

    _unbindEvents() {
      const container = this.scrollContainer;
      if (container) {
        container.removeEventListener('scroll', this._onScroll);
      }
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
    }

    _onScroll() {
      this._updateScrollbar();
      this._updateNavButtons();
    }

    _onResize() {
      this._updateColumnWidth();
      this._updateControls();
      this._updateScrollbar();
      this._updateNavButtons();
    }

    _updateColumnWidth() {
      const container = this.scrollContainer;
      if (!container) return;
      const stickyColWidth = parseFloat(getComputedStyle(this).getPropertyValue('--kik-st-sticky-col-width')) || 0;
      const productCols = container.querySelectorAll('thead th').length || 1;
      const th = container.querySelector('thead th');
      const cellPadding = th
        ? parseFloat(getComputedStyle(th).paddingLeft) + parseFloat(getComputedStyle(th).paddingRight)
        : 0;

      if (stickyColWidth <= 0) {
        // Mobile: 1 col fills full width, 2 cols split equally, 3+ show 2 and scroll
        const visibleCols = Math.min(productCols, 2);
        const colWidth = Math.floor(container.clientWidth / visibleCols) - cellPadding;
        if (colWidth > 0) {
          this.style.setProperty('--kik-st-data-col-width', colWidth + 'px');
        }
        return;
      }

      // Desktop: 1 col fills right, 2 cols split equally, 3+ show 3 and scroll
      const availableWidth = container.clientWidth - stickyColWidth;
      const visibleCols = Math.min(productCols, 3);
      const colWidth = Math.floor(availableWidth / visibleCols);
      if (colWidth > 0) {
        this.style.setProperty('--kik-st-data-col-width', colWidth + 'px');
      }
    }

    _updateControls() {
      const container = this.scrollContainer;
      const controls = this.controls;
      if (!container || !controls) return;
      const isOverflowing = container.scrollWidth > container.clientWidth;
      controls.style.display = isOverflowing ? '' : 'none';
      container.style.justifyContent = isOverflowing ? '' : 'center';
    }

    _getScrollStep() {
      const th = this.scrollContainer && this.scrollContainer.querySelector('thead th:not(.sticky-cell):not(.thead-empty-td)');
      return th ? th.offsetWidth : 250;
    }

    scrollPrev() {
      const container = this.scrollContainer;
      if (!container) return;
      container.scrollBy({ left: -this._getScrollStep(), behavior: 'smooth' });
    }

    scrollNext() {
      const container = this.scrollContainer;
      if (!container) return;
      container.scrollBy({ left: this._getScrollStep(), behavior: 'smooth' });
    }

    _updateNavButtons() {
      const container = this.scrollContainer;
      if (!container || !this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = container;
      const tolerance = 2;
      this.prevBtn.disabled = scrollLeft <= tolerance;
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - tolerance;
    }

    _updateScrollbar() {
      const container = this.scrollContainer;
      const thumb = this.scrollbarThumb;
      if (!container || !thumb) return;

      const { scrollLeft, scrollWidth, clientWidth } = container;

      if (scrollWidth <= clientWidth) {
        thumb.style.width = '0%';
        return;
      }

      const progress = Math.max(0, Math.min(1, scrollLeft / (scrollWidth - clientWidth)));
      thumb.style.width = (progress * 100) + '%';
    }
  }

  customElements.define('kik-scrollable-table', KikScrollableTable);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-slideshow"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('slideshow-words').then(() => {
    customElements.get('slideshow-words').prototype.transition = function(fromElement, toElement) {
      this.items.forEach(item => {
        item.setAttribute('aria-current', parseInt(item.getAttribute('data-index')) === parseInt(this.selectedIndex) ? 'true' : 'false');
      });
    };
  });

  document.querySelectorAll('[data-linked-hover="true"]').forEach(wrapper => {
    const buttons = wrapper.querySelectorAll('a.button, a.link');
    if (buttons.length < 2) return;
    const btn1 = buttons[0];
    const btn2 = buttons[1];
    btn2.addEventListener('mouseenter', () => btn1.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true })));
    btn2.addEventListener('mouseleave', () => btn1.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true })));
  });

  } catch(e) { console.error(e); }
})();
})();
